/* eslint-disable react/no-danger */
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import OrderSummaryPaymentScreen from 'components/OrderSummaryPaymentScreen'
import QantasFrequentFlyerContainer from 'containers/QantasFrequentFlyer'
import GoogleMarketing from 'components/GoogleMarketing'
import styles from './styles.scss'

class SuccessStage extends PureComponent {
  render() {
    const {
      title,
      successText,
      referenceNumber,
      nextStepsText,
      email,
      isAppointmentRequired,
      appointmentRequiredText,
      footerText,
      stageSettings,
      referenceTitle,
      summarySettings,
      qffText,
      qffSuccessText,
      successConversionTracking,
    } = this.props

    const nextStepsWithEmail = nextStepsText.replace('[EMAIL]', email)

    return (
      <div className={styles.wrapper}>
        <GoogleMarketing successConversionTracking={successConversionTracking} />
        <div className={styles.content}>
          <div className={styles.congratulations}>
            <h2>
              <i className={`${styles.greenTick} kgn kgn-icon-checkmark`} /> {title}
            </h2>
            <div dangerouslySetInnerHTML={{ __html: successText }} />
          </div>
          <div className={styles.referenceWrapper}>
            <div className={styles.referenceTitle}>{referenceTitle}</div>
            <div className={styles.referenceNumber}>{referenceNumber}</div>
          </div>
          <div
            className={styles.whatsNextWrapper}
            dangerouslySetInnerHTML={{ __html: nextStepsWithEmail }}
          />
          {isAppointmentRequired &&
          <div
            className={styles.appointmentRequiredText}
            dangerouslySetInnerHTML={{ __html: appointmentRequiredText }}
          />
          }
          <QantasFrequentFlyerContainer
            isSimplePage
            qffText={qffText}
            successText={qffSuccessText}
          />
          {footerText &&
          <div
            className={styles.footerText}
            dangerouslySetInnerHTML={{ __html: footerText }}
          />
          }
        </div>
        <div className={styles.orderSummary}>
          <OrderSummaryPaymentScreen
            stageSettings={stageSettings}
            summarySettings={summarySettings}
          />
        </div>
      </div>
    )
  }
}

SuccessStage.propTypes = {
  // From Wagtail
  title: PropTypes.string,
  successText: PropTypes.string,
  appointmentRequiredText: PropTypes.string,
  qffText: PropTypes.string,
  qffSuccessText: PropTypes.string,
  footerText: PropTypes.string,
  nextStepsText: PropTypes.string,
  referenceTitle: PropTypes.string,
  stageSettings: PropTypes.object,
  summarySettings: PropTypes.object,
  successConversionTracking: PropTypes.arrayOf(PropTypes.shape({
    activityGroupTagString: PropTypes.string,
    activityTagString: PropTypes.string,
    countingMethod: PropTypes.string,
    floodlightConfigID: PropTypes.string,
  })),

  // From store
  referenceNumber: PropTypes.string,
  email: PropTypes.string,
  isAppointmentRequired: PropTypes.bool,
}

SuccessStage.defaultProps = {
  referenceNumber: 'XXYY3456',
  email: 'test@gmail.com',
  isAppointmentRequired: true,
  title: 'Order Successful',
  successText: 'Thanks for placing an order with Kogan Internet',
  nextStepsText:
    "<h2>WHAT'S NEXT?</h2>" +
    "<div>We've just sent a confirmation email for your order to [EMAIL]</div>" +
    '<div>If you have any questions or need more help' +
    ' please call us on <strong>1300 000 000</strong></div>',
  appointmentRequiredText: 'An appointment will be required for installation',
  qffText:
    '<p style="text-align: center;">You can link your Qantas Frequent Flyer number to earn Qantas Points' +
    ' on this order and future orders from Kogan Internet.</p>',
  qffSuccessText: 'You have successfully linked you Qantas Frequent Flyer number to Kogan Internet.',
  footerText: '',
  referenceTitle: 'Customer Reference',
  successConversionTracking: [],
  stageSettings: {},
  summarySettings: {},
}

function mapStateToProps(state) {
  // whatever is returned will show up as props
  return {
    email: state.checkoutReducer.email,
    isAppointmentRequired: state.checkoutReducer.appointmentRequired,
    referenceNumber: state.checkoutReducer.reference,
  }
}

export default connect(mapStateToProps)(SuccessStage)



// WEBPACK FOOTER //
// ./containers/stages/SuccessStage/index.jsx